import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs'

import { MarketplaceReviewSummary } from './marketplace-review.service'

/* ── Marketplace M7/M8: public seller profile (badges + trust score) ──────── */

export type SellerBadgeType =
	| 'IDENTITY_VERIFIED'
	| 'SELLER_VERIFIED'
	| 'REPRESENTATIVE_VERIFIED'
	| 'SECURE_PAYMENT_ENABLED'
	| 'GOOD_STANDING'

/** اعتمادسنجی فروشنده (BeautyBoss Score سمت مارکت‌پلیس). */
export interface SellerTrustScore {
	score?: number | null
	/** 0..100 — «دقت امتیاز»؛ پایین = داده کم برای قضاوت. */
	confidence?: number | null
	computedAt?: string | null
}

/** `GET /seller/profile/{kcUserId}` — عمومی (مهمان هم). */
export interface SellerProfile {
	badges?: SellerBadgeType[] | null
	ratingSummary?: MarketplaceReviewSummary | null
	trustScore?: SellerTrustScore | null
}

/** لیبل/آیکن فارسی هر بج — ترتیب آرایه = ترتیب نمایش. */
export const SELLER_BADGE_META: Record<
	SellerBadgeType,
	{ label: string; icon: string; severity: 'success' | 'info' | 'warn' | 'secondary' }
> = {
	IDENTITY_VERIFIED: { label: 'هویت تأییدشده', icon: 'pi pi-id-card', severity: 'success' },
	SELLER_VERIFIED: { label: 'فروشنده تأییدشده', icon: 'pi pi-verified', severity: 'success' },
	REPRESENTATIVE_VERIFIED: { label: 'نمایندگی تأییدشده', icon: 'pi pi-buildings', severity: 'info' },
	SECURE_PAYMENT_ENABLED: { label: 'پرداخت امن', icon: 'pi pi-shield', severity: 'info' },
	GOOD_STANDING: { label: 'خوش‌سابقه', icon: 'pi pi-star', severity: 'warn' },
}

export function sellerBadgeMeta(type: SellerBadgeType | string) {
	return SELLER_BADGE_META[type as SellerBadgeType] ?? null
}

/**
 * Bridge client for the public seller-profile endpoint (M7). Hand-written
 * bridge pattern — the generated client predates this controller.
 */
@Injectable({ providedIn: 'root' })
export class SellerProfileService {
	private http = inject(HttpClient)
	private base = environment.apiUrl

	getProfile(kcUserId: string): Observable<SellerProfile> {
		return this.http.get<SellerProfile>(`${this.base}/seller/profile/${kcUserId}`)
	}
}
